import { useContext, useState } from "react";
import { Route, Routes } from "react-router-dom";
import {
  LicenseTypes,
  MapPageFor,
  MaterialRequestStatus,
  Operation,
  PageFor,
  PageFromJunction,
  PriorityEnum,
  empType,
} from "../../../../utils/Enum.types";
import ItemOBList from "../../asset/item/item_ob/List";
import ItemIndividualList from "../../asset/item/item_individual/List";
import MaterialIndex from "../../asset/purchase/material/Index";

import Items from "../../asset/masters/items/Index";
import Supplier from "../../asset/masters/supplier/Index";
import BasicDetails from "../../asset/masters/supplier/add/BasicDetails";
import RequiredDetails from "../../asset/masters/supplier/add/RequiredDetails";

import Purchase from "../../asset/purchase/List";
import Add from "../../asset/purchase/Add";
import List from "../../asset/purchase/material/List";
import ViewPendingStatus from "../../asset/purchase/material/pending/ViewPendingStatus";
import Category from "../../asset/masters/category/Index";
import ItemGroup from "../../asset/masters/itemgroup/Index";
import Manufacturer from "../../asset/masters/manufacturer/Index";
import UOM from "../../asset/masters/unitOfMeasurment/Index";
import QuotationList from "../../asset/purchase/quotation/List";
import MultiLocation from "../../asset/masters/supplier/add/MultiLocation";
import RFQIndex from "../../asset/purchase/quotation/Add/Index";
import MaterialQuotationComparison from "../../asset/purchase/quotation/comparision/MaterialQuotationComparison";
import Negotiation, {
  NegotiationPage,
} from "../../asset/purchase/quotation/comparision/Negotiation";
import NegotiateDetails from "../../asset/purchase/quotation/comparision/NegotiateDetails";
import PurchaseOrderList from "../../asset/purchase/purchaseorder/List";
import MRFtoPO from "../../asset/purchase/purchaseorder/mrftopo/MRFtoPO";
import StockEntryAddIndex from "../../asset/purchase/stockentry/Add/StockEntryAddIndex";
import StockBalanceList from "../../asset/purchase/stockbalance/StockBalanceList";
import StockBalanceAdd from "../../asset/purchase/stockbalance/StockBalanceAdd";
import AssociateItems from "../../asset/masters/association/associationItems/AssociateItems";
import PurchaseEntryAcceptance from "../../asset/purchase/acceptance/List";
import Associate from "../../asset/masters/association/Associate";
import SEWithoutPurchaseEntry from "../../asset/purchase/stockentry/List";
import RFQtoPO from "../../asset/purchase/purchaseorder/rfqtopo/RFQtoPO";
import ValidatePurchaseItem from "../../asset/purchase/acceptance/Add";
import SubsidiaryRoutes from "../../asset/masters/subsidary/SubsidiaryRoutes";
import MapsIndex from "../../asset/maps/MapsIndex";
import UsersList from "../../asset/users/Index";
import AssignRights from "../../asset/users/AssignRights/AssignRights";
import AssignedList from "../../asset/users/AssignRights/Index";
import ItemsDetailsImport from "../../asset/item/ImportItemsDetails";
import ImportSite from "../../asset/masters/subsidary/assetsite/ImportSubsidiarySite";
import TicketsRaisedList from "../../asset/maps/ticketdetails/TicketsRaisedList";
import AssociateEmps from "../../asset/masters/association/associationEmpsToVendor/AssociateEmps";
import ImportSubsidiary from "../../asset/masters/subsidary/ImportSubsidiary";
import TicketRaisedListIndex from "../../asset/maps/ticketdetails/TicketRaisedListIndex";
import ImportJunctions from "../../asset/masters/subsidary/junctions/ImportJunctions";
import ItemErrorMessage from "../../asset/masters/items/ItemErrorMsg";
import { TicketStatus } from "../../../../utils/constants";
import EnableUserLogin from "../../asset/users/EnableUserLogin";
import ResetUserPassword from "../../asset/users/ResetUserPassword/ResetUserPassword";
import ProjectDetails from "../../asset/masters/projects";
import DashBoardIndex from "../../asset/DashBoardMapsView/DashboardIndex";
import Grouping from "../../asset/masters/grouping/Grouping";
import GroupingAsset, {
  GroupingListPageFor,
} from "../../asset/masters/grouping/asset/GroupingAsset";
import AssignAsset from "../../asset/masters/grouping/assign/AssignAsset";
import JunctionList from "../../asset/masters/subsidary/junctions/List";
import GroupAssembliesList from "../../asset/masters/grouping/asset/GroupAssembliesList";
import DeviceList from "../../asset/users/UserDeviceList/DeviceList";
import TicketReason from "../../asset/masters/ticketreason/Index";
import DeviceType from "../../asset/masters/deviceType/Index";
import Junctions from "../../asset/masters/subsidary/junctions/List";
import JunctionsItemReplacedList from "../../asset/masters/subsidary/junctions/JunctionsItemReplacedList";
import { AppContext } from "../../../../context/context";
import JunctionItemConutList from "../../asset/masters/subsidary/junctions/JunctionItemConutList";
import JunctionsItemList from "../../asset/masters/subsidary/junctions/JunctionsItemList";

const CompanyRoutes = () => {
  const [modalFlag, setModalFlag] = useState(false);
  const { state } = useContext(AppContext);
  return (
    <Routes>
      <Route
        path="/:companyId/*"
        element={
          <Routes>
            <Route path="/subsidiary/*" element={<SubsidiaryRoutes />} />
            <Route
              path="/masters/*"
              element={
                <>
                  <Routes>
                    <Route
                      path="/grouping/*"
                      element={
                        <>
                          <Routes>
                            <Route path="/" element={<Grouping />} />
                            <Route
                              path="/asset"
                              element={
                                <GroupingAsset
                                  pageType={GroupingListPageFor.GENERAL}
                                />
                              }
                            />
                            <Route path="/assign" element={<AssignAsset />} />
                            <Route
                              path="/assign/:groupId"
                              element={<GroupAssembliesList />}
                            />
                          </Routes>
                        </>
                      }
                    />
                  </Routes>
                </>
              }
            />
            <Route
              path="/junctions"
              element={
                <JunctionList
                  setModalFlag={setModalFlag}
                  pageType={PageFor.GENERAL}
                />
              }
            />
            <Route
              path="/importitemdetails"
              element={
                <ItemsDetailsImport
                  setModalFlag={setModalFlag}
                  pageType={PageFor.GENERAL}
                  NavType={LicenseTypes.COMPANY}
                  bulkAlterPage={false}
                />
              }
            />
            <Route
              path="/bulkalteritemdetails"
              element={
                <ItemsDetailsImport
                  setModalFlag={setModalFlag}
                  pageType={PageFor.GENERAL}
                  NavType={LicenseTypes.COMPANY}
                  bulkAlterPage={true}
                />
              }
            />
            <Route
              path="/importassetsite"
              element={
                <ImportSite
                  setModalFlag={setModalFlag}
                  pageType={PageFor.GENERAL}
                  NavType={LicenseTypes.COMPANY}
                />
              }
            />
            <Route
              path="/importsubsidiary"
              element={
                <ImportSubsidiary
                  setModalFlag={setModalFlag}
                  pageType={PageFor.GENERAL}
                  NavType={LicenseTypes.COMPANY}
                />
              }
            />

            <Route
              path="/importjunction"
              element={
                <ImportJunctions
                  setModalFlag={setModalFlag}
                  pageType={PageFor.GENERAL}
                  NavType={LicenseTypes.COMPANY}
                />
              }
            />
            <Route
              path="/item/*"
              element={
                <Routes>
                  <Route
                    path="/list"
                    element={
                      <Items
                        setModalFlag={setModalFlag}
                        pageType={PageFor.GENERAL}
                      />
                    }
                  />
                  <Route
                    path="ob/list"
                    element={<ItemOBList NavType={LicenseTypes.COMPANY} />}
                  />
                  <Route
                    path="individual/list"
                    element={
                      <ItemIndividualList NavType={LicenseTypes.COMPANY} />
                    }
                  />
                </Routes>
              }
            />

            <Route
              path="/purchase/*"
              element={
                <>
                  <Routes>
                    <Route path="/entry" element={<Purchase />} />
                    <Route path="/add" element={<Add />} />
                    <Route
                      path="/material/*"
                      element={
                        <Routes>
                          <Route
                            path="/request"
                            element={
                              <List pageType={MaterialRequestStatus.APPROVED} />
                            }
                          />
                          <Route
                            path="/pending"
                            element={
                              <List pageType={MaterialRequestStatus.PENDING} />
                            }
                          />
                          <Route path="/add" element={<MaterialIndex />} />
                          <Route
                            path="/:mrf_id/edit"
                            element={<MaterialIndex />}
                          />
                          <Route
                            path="/pending/:mrf_id/view"
                            element={
                              <ViewPendingStatus
                                pageType={PageFor.GENERAL}
                                type={MaterialRequestStatus.PENDING}
                                setModalFlag={setModalFlag}
                              />
                            }
                          />
                        </Routes>
                      }
                    />
                    <Route
                      path="/quotation/*"
                      element={
                        <Routes>
                          <Route path="/" element={<QuotationList />} />
                          <Route path="/add" element={<RFQIndex />} />
                          <Route path="/:rfqId/edit" element={<RFQIndex />} />
                        </Routes>
                      }
                    />
                    <Route
                      path="/mqcomparision"
                      element={<MaterialQuotationComparison />}
                    />
                    <Route
                      path="/mqcomparision/negotiation"
                      element={
                        <Negotiation pageType={NegotiationPage.GENERAL} />
                      }
                    />
                    <Route
                      path="/mqcomparision/:rfqId/view"
                      element={<Negotiation pageType={NegotiationPage.VIEW} />}
                    />
                    <Route
                      path="/mqcomparision/negotiation/preview"
                      element={
                        <Negotiation pageType={NegotiationPage.PREVIEW} />
                      }
                    />
                    <Route
                      path="/mqcomparision/:rfqId/:rfqTrnSupplyId/negotiation/filldetails"
                      element={<NegotiateDetails />}
                    />
                    <Route
                      path="/mqcomparision"
                      element={<MaterialQuotationComparison />}
                    />
                    <Route
                      path="/purchaseorder"
                      element={<PurchaseOrderList />}
                    />
                    <Route
                      path="/acceptance"
                      element={<PurchaseEntryAcceptance />}
                    />
                    <Route
                      path="/acceptance/validate"
                      element={<ValidatePurchaseItem />}
                    />
                    <Route
                      path="/purchaseorder/mrftopo"
                      element={<MRFtoPO />}
                    />
                    <Route
                      path="/purchaseorder/rfqtopo"
                      element={<RFQtoPO />}
                    />

                    <Route
                      path="/stockentry/*"
                      element={
                        <Routes>
                          <Route
                            path="/withoutpurchaseentry"
                            element={<SEWithoutPurchaseEntry />}
                          />
                          <Route
                            path="/withoutpurchaseentry/add"
                            element={
                              <StockEntryAddIndex
                                setModalFlag={setModalFlag}
                                pageType={PageFor.GENERAL}
                              />
                            }
                          />
                        </Routes>
                      }
                    />
                    <Route
                      path="/stockbalance/*"
                      element={
                        <Routes>
                          <Route path="/list" element={<StockBalanceList />} />
                          <Route
                            path="/add"
                            element={
                              <StockBalanceAdd pageType={PageFor.GENERAL} />
                            }
                          />
                        </Routes>
                      }
                    />
                  </Routes>
                </>
              }
            />

            <Route
              path="/maps"
              element={
                <MapsIndex
                  NavType={LicenseTypes.COMPANY}
                  pageFor={MapPageFor.VIEW}
                />
              }
            />
            <Route
              path="/ticketing"
              element={
                <DashBoardIndex
                  NavType={LicenseTypes.COMPANY}
                  pageFor={MapPageFor.TICKET}
                />
              }
            />
            <Route
              path="/assets"
              element={
                <TicketsRaisedList
                  NavType={LicenseTypes.COMPANY}
                  pageFor={MapPageFor.VIEW}
                  ticketStatusType={TicketStatus.ALL}
                  setModalFlag={setModalFlag}
                  ticketPriority={PriorityEnum.ALL}
                />
              }
            />
            <Route
              path="/users/*"
              element={
                <>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <UsersList
                          setModalFlag={setModalFlag}
                          modalFlag={modalFlag}
                        />
                      }
                    />
                    <Route path="/assignedlist" element={<AssignedList />} />

                    <Route
                      path="/:userId/assignrights"
                      element={<AssignRights />}
                    />
                  </Routes>
                </>
              }
            />

            <Route
              path="/raisedticketdetails"
              element={
                <TicketRaisedListIndex
                  NavType={LicenseTypes.COMPANY}
                  pageFor={MapPageFor.TICKET}
                  ticketStatusType={TicketStatus.ALL}
                  setModalFlag={setModalFlag}
                  ticketPriority={PriorityEnum.ALL}
                />
              }
            />
          </Routes>
        }
      />
      <Route
        path="/masters/*"
        element={
          <>
            <Routes>
              <Route
                path="/itemgroup"
                element={
                  <ItemGroup type={PageFor.GENERAL} setModal={setModalFlag} />
                }
              />
              <Route
                path="/category"
                element={
                  <Category type={PageFor.GENERAL} setModal={setModalFlag} />
                }
              />
              <Route
                path="/manufacturer"
                element={<Manufacturer type={PageFor.GENERAL} />}
              />
              <Route
                path="/unitofmeasurement"
                element={<UOM type={PageFor.GENERAL} setModal={setModalFlag} />}
              />
              <Route
                path="/items"
                element={
                  <Items
                    pageType={PageFor.GENERAL}
                    setModalFlag={setModalFlag}
                  />
                }
              />
              <Route
                path="/itemserrormessage"
                element={<ItemErrorMessage pageType={PageFor.GENERAL} />}
              />
              <Route
                path="/supplier"
                element={
                  <Supplier
                    pageType={PageFor.GENERAL}
                    setModalFlag={setModalFlag}
                  />
                }
              />
              <Route
                path="/supplier/:supplier_id/basicdetails"
                element={
                  <BasicDetails
                    setModalFlag={setModalFlag}
                    operation={Operation.CREATE}
                    step={1}
                  />
                }
              />
              <Route
                path="/supplier/:supplier_id/requiredDetails"
                element={
                  <RequiredDetails
                    setModalFlag={setModalFlag}
                    operation={Operation.CREATE}
                    step={2}
                  />
                }
              />

              <Route
                path="/supplier/:supplier_id/multipleLocation"
                element={
                  <MultiLocation
                    pageType={PageFor.GENERAL}
                    setModalFlag={setModalFlag}
                    operation={Operation.CREATE}
                    step={2}
                  />
                }
              />

              <Route
                path="/projectDetails"
                element={
                  <ProjectDetails
                    pageType={PageFor.GENERAL}
                    setModalFlag={setModalFlag}
                  />
                }
              />
              <Route
                path="/geoValidJunctions"
                element={
                  <Junctions
                    pageType={PageFor.GENERAL}
                    setModalFlag={setModalFlag}
                    pageForm={PageFromJunction.GEO_ENABLED}
                  />
                }
              />
              <Route
                path="/geoValidJunctions/:junctionID/itemcountlist"
                element={
                  <JunctionItemConutList
                    NavType={LicenseTypes.CUSTOMER_USERS}
                  />
                }
              />

              <Route
                path="/geoValidJunctions/:junctionID/itemcountlist/:itemId/itemslist"
                element={
                  <JunctionsItemList
                    pageType={PageFor.GENERAL}
                    NavType={LicenseTypes.CUSTOMER_USERS}
                    setModalFlag={setModalFlag}
                  />
                }
              />

              <Route
                path="/ticketReason"
                element={
                  <TicketReason
                    type={PageFor.GENERAL}
                    setModal={setModalFlag}
                  />
                }
              />
              <Route
                path="/deviceType"
                element={
                  <DeviceType type={PageFor.GENERAL} setModal={setModalFlag} />
                }
              />
            </Routes>
            <Routes>
              <Route
                path="/assoc/*"
                element={
                  <Routes>
                    <Route path="/" element={<Associate />} />
                    <Route path="/itemstovendor" element={<AssociateItems />} />
                    <Route
                      path="/employeestovendor"
                      element={<AssociateEmps />}
                    />
                  </Routes>
                }
              />
            </Routes>
          </>
        }
      />

      <Route
        path="/users/*"
        element={
          <>
            <Routes>
              <Route
                path="/"
                element={
                  <UsersList
                    setModalFlag={setModalFlag}
                    modalFlag={modalFlag}
                  />
                }
              />
              <Route path="/assignedlist" element={<AssignedList />} />
              <Route
                path="/resetuserpassword"
                element={<ResetUserPassword />}
              />
              <Route path="/enableuserlogin" element={<EnableUserLogin />} />
              <Route path="/devicelist" element={<DeviceList />} />
              <Route path="/:userId/assignrights" element={<AssignRights />} />
            </Routes>
          </>
        }
      />

      <Route
        path="/reports/*"
        element={
          <>
            <Routes>
              <Route
                path="/componentreport"
                element={
                  <JunctionsItemReplacedList
                    pageType={PageFor.GENERAL}
                    NavType={
                      state.empSubType === empType.TECHNICIAN
                        ? LicenseTypes.TECHNICIAN_DASHBOARD
                        : state.empSubType === empType.SYS_ADMIN
                          ? LicenseTypes.CUSTOMER_USERS
                          : LicenseTypes.NONE
                    }
                    setModalFlag={setModalFlag}
                  />
                }
              />
            </Routes>
          </>
        }
      />
    </Routes>
  );
};

export default CompanyRoutes;
